import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import dayjs from 'dayjs';
import './index.css';
import SessionEvents from '../sessionEvents';
import EventFilters from '../eventFilters';
import { useNavigate } from 'react-router-dom';
import Button from '@components/common/Button';
import DownArrow from '@assets/svg/download-01.svg';
import { getSessionSiteDownloadApi } from '../sessionServices';
import json2xls from 'json-as-xlsx';
import { status_type } from '@constants/sessionSiteConstant';
import Delete from '../../../../assets/svg_main/delete.svg';
import EyeOutline from '../../../../assets/svg_main/eye-open.svg';
import EditOutline from '../../../../assets/svg_main/edit_outline.svg';
import { dateFormate } from '@constants/index';

moment.locale('en-GB');
const localizer = momentLocalizer(moment);

const colors: any = {
  vhnd: '#af2d94',
  uhnd: '#b49cc4',
  outreach: '#a8c4d4',
};

const typeFilters = [
  { key: 'all', value: 'All', textColor: '#797979' },
  { key: 'vhnd', value: 'VHND', color: '#af2d94', textColor: '#ffffff' },
  { key: 'uhnd', value: 'UHND', color: '#b49cc4', textColor: '#ffffff' },
  { key: 'outreach', value: 'Outreach', color: '#a8c4d4', textColor: '#ffffff' },
];

const SessionCalendarView: React.FC<{
  sessionsData: any;
  sessionsViewListData: any;
  sessionsDataCount: any;
  setShowWarningModal: any;
  setSessionStatusType: any;
  setSessionId: any;
  eventsOnDate: any;
  selectedDate: any;
  sessionFilterHandler: any
  getSessionDetailsByDateSessionSite: (date: any) => void;
  handleCalenderActionButtons: (date: any) => void;
}> = ({ sessionsData, sessionsViewListData, sessionsDataCount, setShowWarningModal, setSessionStatusType, setSessionId, eventsOnDate, getSessionDetailsByDateSessionSite, handleCalenderActionButtons, selectedDate, sessionFilterHandler }) => {
  const [eventsData, setEventsData] = useState(sessionsData);
  const [allEventsData, setAllEventsData] = useState(sessionsData);
  const [eventListData, setEventListData] = useState(sessionsViewListData);
  const [allEventListData, setAllEventListData] =
    useState(sessionsViewListData);
  const [calendarDate, setCalendarDate] = useState<any>(moment(new Date()).startOf('month').toDate());
  const [view, setView] = useState<any>(Views.MONTH);
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<any>(typeFilters[0].key);

  const handleViewpage = (sessionId: any) => {
    navigate(`/VHND/view/${sessionId}`);
  };

  // edit
  const handleEditpage = (event: any, sessionId: any) => {
    event.stopPropagation();
    navigate(`/VHND/edit/${sessionId}`);
  };

  const CustomEvent = ({ event }: any) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {event?.types?.map((type: any, i: any) => (
          <div
            className="customEventDiv"
            key={i}
            style={{
              backgroundColor: colors[type],
            }}
          ></div>
        ))}
      </div>
    );
  };

  const handleDeleteSession = (event: any, sessionId: any) => {
    event.stopPropagation();
    setSessionStatusType('delete');
    setShowWarningModal(true);
    setSessionId(sessionId);
  };

  const createReturnData = (sessionDate: any, currentDate: any) => {
    const data = (sessionDate.isBefore(currentDate)) ? false : true;
    return data;
  };

  const createDate = (sessionStartDate: any) => {
    const sessionDate = dayjs(dayjs(sessionStartDate).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
    const currentDate = dayjs(dayjs(new Date()).format(dateFormate.yyyy_mm_dd), dateFormate.yyyy_mm_dd);
    const data = {
      sessionDate: sessionDate,
      currentDate: currentDate
    }
    return data;
  };

  const handleShowEditButton = (sessionStartDate: any) => {
    const { sessionDate, currentDate } = createDate(sessionStartDate);
    return createReturnData(sessionDate, currentDate);
  };

  const CustomAgendaEvent = ({ event }: any) => {
    return (
      <div
        className="customAgendaEventDiv"
        style={{
          borderLeft: `4px solid ${colors[event?.type]}`,
        }}
      >
        <span>{event.title}</span>

        <div className="status_box">
          {event?.session_status_code ==
            status_type.cancle.session_status_code && (<>
              <span className="statusbadges">{event?.session_status_name}</span>
            </>)}
          <span
            onClick={() =>
              handleViewpage(event?.session_id)
            }
            className='eye-icon'
          >
            <EyeOutline />
          </span>
          {(event?.session_status_code ==
            status_type.create.session_status_code && handleShowEditButton(event?.start)) && (<>
              <span
                data-testid='edit-icon'
                onClick={($event: any) =>
                  handleEditpage($event, event?.session_id)
                }
              >
                <EditOutline />
              </span>
            </>)}
          {event?.session_status_code ==
            status_type.cancle.session_status_code && (<>
              <span
                data-testid="delete-session"
                onClick={($event: any) =>
                  handleDeleteSession($event, event?.session_id)
                }
              >
                <Delete />
              </span>
            </>)}
        </div>
      </div>
    );
  };

  useEffect(() => {
    setEventsData(sessionsData);
    setAllEventsData(sessionsData);
  }, [sessionsData]);

  useEffect(() => {
    setEventListData(sessionsViewListData);
    setAllEventListData(sessionsViewListData);
  }, [sessionsViewListData]);

  const getSessionDataByDate = (date: any, sessionId: any) => {
    const newdate = new Date(date);
    if (view == Views.AGENDA) {
      handleViewpage(sessionId);
    } else {
      getSessionDetailsByDateSessionSite(newdate);
    }
  };

  const dayStyleGetter = (date: any) => {
    const style: any = {};

    if (
      selectedDate &&
      date.getFullYear() === selectedDate.getFullYear() &&
      date.getMonth() === selectedDate.getMonth() &&
      date.getDate() === selectedDate.getDate()
    ) {
      style.border = '2px solid black';
      style.borderRadius = '4px';
    }

    return {
      style,
    };
  };

  const filterSessionData = (filters: any) => {
    /* Calendar view data filter */
    setSelectedType(filters.type);
    const newEventsData = [...allEventsData];
    const filteredData = newEventsData?.filter((el: any) => {
      let matched = true;
      if (filters?.type !== 'all') matched = el?.types?.includes(filters.type);
      return matched;
    });

    /* Grid view data filter */
    const newEventListData = [...allEventListData];
    const filteredEventListData = newEventListData?.filter((el: any) => {
      let matched = true;
      if (filters?.type !== 'all') matched = el?.type == filters.type;
      return matched;
    });

    setEventsData(filteredData);
    setEventListData(filteredEventListData);
    sessionFilterHandler(filters?.type)
  };

  const navigateToMonth = (date: any, view: any, action: any) => {
    let newDate: any;
    if (view === Views.AGENDA) {
      if (action === 'NEXT') {
        newDate = moment(calendarDate).add(1, 'month').startOf('month').toDate();
      } else if (action === 'PREV') {
        newDate = moment(calendarDate).subtract(1, 'month').startOf('month').toDate();
      } else {
        newDate = moment().startOf('month').toDate();
      }
    } else {
      newDate = moment(date).startOf('month').toDate()
    } 
    setCalendarDate(newDate);
    setSelectedType(typeFilters[0].key);
    handleCalenderActionButtons(newDate);
  };

  const downloadFile = (downloadData: any) => {
    const excelData = downloadData.map((item: any, index: any) => ({
      serialNo: index + 1,
      ...item,
    }));
    const dataToExportExcel = [
      {
        sheet: 'Session Detail Report',
        columns: [
          { label: 'Sl.No.', value: 'serialNo' },
          { label: 'Session Name', value: 'session_name' },
          { label: 'Session Planned Date', value: 'session_planned_date' },
          { label: 'Session Type', value: 'session_type_name' },
          { label: 'Session Held At', value: 'session_held_at_name' },
          { label: 'Session Site Address', value: 'session_site_address' },
          { label: 'Facility Name', value: 'facility_name' },
          { label: 'Health Provider Tagged', value: 'health_provider_tagged' },
          { label: 'Mobiliser Tagged', value: 'mobiliser_tagged' },
          { label: 'Village Coverage', value: 'village_coverage' },
          { label: 'Ward Coverage', value: 'ward_coverage' },
          { label: 'Coverage Area', value: 'coverage_area' },
          { label: 'Session Status', value: 'session_status_name' },
        ],
        content: excelData,
      },
    ];

    json2xls(dataToExportExcel, {
      fileName: 'Session Detail Report',
      extraLength: 3, // A bigger number means that columns will be wider
    });
  };

  const getSessionSiteDownloadData = async () => {
    const res = await getSessionSiteDownloadApi();
    if (res) {
      const downloadData = res.data.map((ele: any) => {
        return {
          ...ele,
          session_planned_date: dayjs(ele.session_planned_date).format(
            dateFormate.dd_mm_yyyy,
          ),
          health_provider_tagged: ele.health_provider_tagged ? ele.health_provider_tagged.map((name: any) => {
            return `${name.health_provider_f_name} ${name.health_provider_l_name}`
          }).join(', ') : '',
          mobiliser_tagged: ele.mobiliser_tagged ? ele.mobiliser_tagged.map((name: any) => {
            return `${name.mobiliser_f_name} ${name.mobiliser_l_name}`
          }).join(', ') : '',
          coverage_area: ele.coverage_area ? ele.coverage_area.map((name: any) => {
            return `${name.coverage_area}`
          }).join(', ') : '',
          village_coverage: ele.village_coverage ? ele.village_coverage.map((name: any) => {
            return `${name.village_name}`
          }).join(', ') : '',
          ward_coverage: ele.ward_coverage ? ele.ward_coverage.map((name: any) => {
            return `${name.ward_name}`
          }).join(', ') : '',
        };
      });
      downloadFile(downloadData);
    }
  };

  return (
    <>
      <EventFilters
        typeFilters={typeFilters}
        selectedType={selectedType}
        filterSessionData={filterSessionData}
        calendarDate={calendarDate}
        setView={setView}
        view={view}
        Views={Views}
      />

      <div className="calendarMainDiv">
        <div className="calenderBox">
          <div className="action_calender">
            <div className="actionDiv">
              <p style={{ margin: '0' }}>
                Showing results: {sessionsDataCount}
              </p>
              <Button
                onClick={getSessionSiteDownloadData}
                disabled={false}
                id="download-Session"
                data-testid="download-session"
                buttonName={'Download results'}
                colorType={'duplicate'}
                icon={<DownArrow />}
                iconPosition={'left'}
              />
            </div>
            <Calendar
              date={calendarDate}
              views={['month', 'agenda']}
              view={view}
              onView={setView}
              length={moment(calendarDate).daysInMonth()}
              step={60}
              selectable
              localizer={localizer}
              defaultDate={moment(new Date()).startOf('month').toDate()}
              defaultView="month"
              events={view == Views.MONTH ? eventsData : eventListData}
              style={{
                height: 450,
                width: '100%',
              }}
              dayPropGetter={dayStyleGetter}
              onSelectEvent={(event: any) => {
                getSessionDataByDate(
                  event?.start,
                  view == Views.AGENDA ? event?.session_id : '',
                );
              }}
              onSelectSlot={(date: any) => {
                getSessionDataByDate(date.start, '');
              }}
              onNavigate={(date, view, action) => {
                navigateToMonth(date, view, action);
              }}
              components={{
                event: view == Views.MONTH ? CustomEvent : CustomAgendaEvent,
              }}
              startAccessor="start"
              endAccessor="end"
            />
          </div>

          {view == Views.MONTH && (
            <SessionEvents
              selectedDate={selectedDate}
              eventsData={eventsOnDate}
              colors={colors}
              setShowWarningModal={setShowWarningModal}
              setSessionStatusType={setSessionStatusType}
              setSessionId={setSessionId}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SessionCalendarView;
